import { AG_GAME_CONFIG, SLOT_GAME_CONFIG, CHESS_GAME_CONFIG } from './constants';
import uni from './webview';
import Vue from 'vue';
/**
 * 时间格式化
 * @param {*} time 时间字符串 时间戳
 * @param {*} fmt 格式字符串'yyyy-MM-dd hh:mm:ss'
 */

export function dateFormat(time, fmt = 'yyyy-MM-dd hh:mm:ss') {
	if (typeof time == 'string') {
		time = Number(time);
	}
	let date = time ? new Date(time) : new Date();
	let o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds(), //毫秒
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (let k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}
	return fmt;
}

/**
 * @desc   函数节流。
 * 适用于限制`resize`和`scroll`等函数的调用频率
 *
 * @param  {Number}    delay          0 或者更大的毫秒数。 对于事件回调，大约100或250毫秒（或更高）的延迟是最有用的。
 * @param  {Boolean}   noTrailing     可选，默认为false。
 *                                    如果noTrailing为true，当节流函数被调用，每过`delay`毫秒`callback`也将执行一次。
 *                                    如果noTrailing为false或者未传入，`callback`将在最后一次调用节流函数后再执行一次.
 *                                    （延迟`delay`毫秒之后，节流函数没有被调用,内部计数器会复位）
 * @param  {Function}  callback       延迟毫秒后执行的函数。`this`上下文和所有参数都是按原样传递的，
 *                                    执行去节流功能时，调用`callback`。
 * @param  {Boolean}   debounceMode   如果`debounceMode`为true，`clear`在`delay`ms后执行。
 *                                    如果debounceMode是false，`callback`在`delay` ms之后执行。
 *
 * @return {Function}  新的节流函数
 */

export function throttle(delay, noTrailing, callback, debounceMode) {
	let timeoutID;
	// Keep track of the last time `callback` was executed.
	let lastExec = 0;
	// `noTrailing` defaults to falsy.
	if (typeof noTrailing !== 'boolean') {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}
	function wrapper() {
		let self = this;
		let elapsed = Number(new Date()) - lastExec;
		let args = arguments;
		// Execute `callback` and update the `lastExec` timestamp.
		function exec() {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}
		function clear() {
			timeoutID = undefined;
		}
		if (debounceMode && !timeoutID) {
			exec();
		}
		// Clear any existing timeout.
		if (timeoutID) {
			clearTimeout(timeoutID);
		}
		if (debounceMode === undefined && elapsed > delay) {
			exec();
		} else if (noTrailing !== true) {
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}
	}
	// Return the wrapper function.
	return wrapper;
}
/**
 * @desc 函数防抖
 * 与throttle不同的是，debounce保证一个函数在多少毫秒内不再被触发，只会执行一次，
 * 要么在第一次调用return的防抖函数时执行，要么在延迟指定毫秒后调用。
 * @example 适用场景：如在线编辑的自动存储防抖。
 * @param  {Number}   delay         0或者更大的毫秒数。 对于事件回调，大约100或250毫秒（或更高）的延迟是最有用的。
 * @param  {Boolean}  atBegin       可选，默认为false。
 *                                  如果`atBegin`为false或未传入，回调函数则在第一次调用return的防抖函数后延迟指定毫秒调用。
                                    如果`atBegin`为true，回调函数则在第一次调用return的防抖函数时直接执行
 * @param  {Function} callback      延迟毫秒后执行的函数。`this`上下文和所有参数都是按原样传递的，
 *                                  执行去抖动功能时，，调用`callback`。
 *
 * @return {Function} 新的防抖函数。
 */
export function debounce(delay, atBegin, callback) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

/**
 * 打开网址
 * @param {*} url 跳转网址
 * @param {*} type  inner在内部打开
 */
export const openUrl = debounce(1000, true, function(url, type) {
	let app = false;
	uni.getEnv(function(res) {
		app = res.plus === true;
	});
	if (app) {
		if (type == 'inner') {
			uni.navigateTo({
				url: '/pages/web/web?gopath=' + url,
			});
			return;
		}
		// eslint-disable-next-line no-undef
		return plus.runtime.openURL(url);
	}
	let tw = window.open('_blank');
	tw.location = url;
	// window.open(url);
});

/**
 * 数值转换中文
 * 万级一下自动补四位小数，不够补0
 * @param {*} number 要转化的数字
 * @param {*} fixedCount 小数位数
 */
export function transNum2Cn(number, fixedCount) {
	if (typeof fixedCount == 'undefined') fixedCount = 4;
	let n = Number(number);
	if (n == 'NaN' || n == 0) {
		return '0元';
	}
	if (n < 10000) {
		return n.toFixed(fixedCount) + '元';
	}
	let w = Math.trunc(n / 10000);

	let n2 = n.toString();
	let nq1 = Math.trunc(n2.substr(1));
	let nq2 = Math.trunc(n2.substr(2));
	let nq3 = Math.trunc(n2.substr(3));
	let nq4 = Math.trunc(n2.substr(4));
	let nq5 = Math.trunc(n2.substr(5));

	if (w < 1) {
		return `${n2}元`;
	} else if (w < 10) {
		return `${w}万${nq1 > 0 ? nq1 : ''}元`;
	} else if (w < 100) {
		return `${w}万${nq2 > 0 ? nq2 : ''}元`;
	} else if (w < 1000) {
		return `${w}万${nq3 > 0 ? nq3 : ''}元`;
	} else if (w < 10000) {
		return `${w}万${nq4 > 0 ? nq4 : ''}元`;
	} else {
		let y = w / 10000;
		if (y >= 1) {
			return `${y}亿${n2.substr(n2.length - 4) == '0000' ? '' : n2.substr(n2.length - 4)}元`;
		}
	}
}
/**
 * 大陆手机号码校验格式
 * @param  str 手机号
 * @return  Boolean
 */
export function IsMobile(str) {
	const patrn = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[35678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/; // 手机号码
	return patrn.test(str);
}
/**
 *  @desc 验证字符串是否为email
 */
export function IsEmail(str) {
	const emailReg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)*\.[\w-]+$/i;
	return emailReg.test(str);
}
/**
 * @description 身份证号合法性验证（合法返回true,不合法返回false）
 * @description 支持15位和18位身份证号
 * @description 支持地址编码、出生日期、校验位验证
 * @param {string} code 传入的身份证号码
 * @param {boolean} return 合法返回true,不合法返回false
 */
export function IdentityCodeValid(code) {
	let city = {
		11: '北京',
		12: '天津',
		13: '河北',
		14: '山西',
		15: '内蒙古',
		21: '辽宁',
		22: '吉林',
		23: '黑龙江 ',
		31: '上海',
		32: '江苏',
		33: '浙江',
		34: '安徽',
		35: '福建',
		36: '江西',
		37: '山东',
		41: '河南',
		42: '湖北 ',
		43: '湖南',
		44: '广东',
		45: '广西',
		46: '海南',
		50: '重庆',
		51: '四川',
		52: '贵州',
		53: '云南',
		54: '西藏 ',
		61: '陕西',
		62: '甘肃',
		63: '青海',
		64: '宁夏',
		65: '新疆',
		71: '台湾',
		81: '香港',
		82: '澳门',
		91: '国外 ',
	};
	let pass = true;
	//验证身份证格式（6个地区编码，8位出生日期，3位顺序号，1位校验位）
	if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
		// 　　tip = "身份证号格式错误";
		pass = false;
	} else if (!city[code.substr(0, 2)]) {
		// 　　tip = "地址编码错误";
		pass = false;
	} else {
		//18位身份证需要验证最后一位校验位
		if (code.length == 18) {
			code = code.split(''); //∑(ai×Wi)(mod 11)
			//加权因子
			let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			//校验位
			let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
			let sum = 0;
			let ai = 0;
			let wi = 0;
			for (var i = 0; i < 17; i++) {
				ai = code[i];
				wi = factor[i];
				sum += ai * wi;
			}
			// let last = parity[sum % 11];
			if (parity[sum % 11] != code[17]) {
				// tip = "校验位错误";
				pass = false;
			}
		}
	}
	return pass;
}
/**
 *  @desc 有效金额大于1的正整数
 */
export function validamount(str) {
	const validamount = /^[1-9]*[1-9][0-9]*$/;
	return validamount.test(str);
}
/**
 *  @desc 只能输入数字
 */
export function validnumber(str) {
	const validnumber = /^[0-9]*$/;
	return validnumber.test(str);
}
/**
 *  @desc 中文汉字
 */
export function validChinese(str) {
	const validChinese = /^[\u4e00-\u9fa5]+$/;
	return validChinese.test(str);
}

/**
 * @desc 判断是否为正确的银行卡号,正确返回true，否则返回false
 * @desc Luhm校验规则：16位银行卡号（19位通用）:
 * @argument {string} bankno 传入用来进行判断的参数
 * @param {boolean} return(param) 正确返回true,错误返回false
 */
export function isBankCardNo(bankno) {
	// 银行卡号长度必须在16到19之间
	if (bankno.length < 16 || bankno.length > 19) {
		return false;
	}
	let num = /^\d*$/; //全数字
	// 银行卡号必须全为数字
	if (!num.exec(bankno)) {
		return false;
	}
	return true;
}

// 字符转义
function escapeHtml(str) {
	if (str) {
		var arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
		return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
			return arrEntities[t];
		});
	}
}
/**
 * 打开浏览器窗口
 * @require url
 * @require target: _system,_blank;
 * 默认打开系统浏览器
 */
function openNewWindow(url, target) {
	let targetType = target ? target : '_system';
	let ref = '';
	if (window.cordova && window.cordova.InAppBrowser) {
		ref = window.cordova.InAppBrowser.open(
			url,
			targetType,
			'location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=关闭'
		);
		ref.show();
	} else {
		window.open(url, '_blank');
	}
}

/**
 * @desc
 * @argument 下载图片判断
 * @param
 */
function accessPermission($Vue, type, elid) {
	let u = navigator.userAgent;
	//	u.indexOf('Android') > -1 || u.indexOf('Linux') > -1);
	if (window.cordova) {
		if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
			savePic($Vue, type, elid);
		} else {
			let permissions = cordova.plugins.permissions;
			permissions.checkPermission(
				permissions.WRITE_EXTERNAL_STORAGE,
				function(s) {
					if (!s.hasPermission) {
						permissions.requestPermission(
							permissions.WRITE_EXTERNAL_STORAGE,
							function(s) {
								if (s.hasPermission) {
									savePic($Vue, type, elid);
								}
							},
							function(error) {}
						);
					} else {
						savePic($Vue, type, elid);
					}
				},
				function(error) {}
			);
		}
	}
}
/**
 * 保存图片到相册
 * vue
 * type：img/canvas
 * el: id
 *
 */
function savePic($Vue, type, elid) {
	if (window.cordova) {
		if (type == 'img') {
			let image = document.getElementById(elid);
			let canvas = document.createElement('canvas');
			canvas.width = image.width;
			canvas.height = image.height;
			canvas.getContext('2d').drawImage(image, 0, 0);
			window.canvas2ImagePlugin.saveImageDataToLibrary(
				function(msg) {
					$Vue.$toast('保存成功');
				},
				function(err) {
					$Vue.$toast('保存失败');
				},
				canvas
			);
		} else if (type == 'canvas') {
			let canvas = document.getElementById(elid).childNodes[0];
			window.canvas2ImagePlugin.saveImageDataToLibrary(
				function(msg) {
					$Vue.$toast('保存成功');
				},
				function(err) {
					$Vue.$toast('保存失败');
				},
				canvas,
				'png'
			);
		}
	}
}

/**
 * 设备判断
 *
 */
function getBeviceInfo() {
	let ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	if (window.cordova && ios) {
		//iphone X  手机模型或者分辨率
		let deviceModel = device.model;
		if (deviceModel.indexOf('iPhone10,3') != -1 || deviceModel.indexOf('iPhone10,6') != -1) {
			return true;
		} else if (
			(window.innerWidth == 375 && window.innerHeight == 812) ||
			(window.screen.width === 414 && window.screen.height === 896)
		) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}
//判断登录设配
function getBeviceType() {
	if (window.cordova) {
		let u = window.navigator.userAgent.toLowerCase();
		let isIOS = !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/); //ios终端
		if (isIOS) {
			return 'ios';
		} else {
			return 'android';
		}
	} else {
		return 'h5';
	}
}
function getBrowserBevice(){
	//识别pc和H5,并重定向网址
	var mobileBrowser = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
	var theH5Index = location.host.indexOf('h5.')>-1;
	if(location.host.indexOf('test') >-1){
		if(!theH5Index && mobileBrowser){
			location.href = location.origin.replace(/pc/, "h5");
		}else if(theH5Index && !mobileBrowser){
			location.href = location.origin.replace(/h5/, "pc");
		}
	}else{
		if (mobileBrowser && !theH5Index) {
			var h5url='h5.'+location.host;
			if(location.host.indexOf('www.')>-1){
				h5url = location.host.replace(/www/, "h5")
			}
			location.href =  location.protocol+'//'+h5url;
		}else if(!mobileBrowser && theH5Index){
			location.href = location.origin.replace(/h5./, "");
		}
	}
}
//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('realImg', async function(el, binding) {
	//指令名称为：real-img
	let imgURL = binding.value; //获取图片地址
	if (imgURL) {
		let exist = await imageIsExist(imgURL);
		if (exist) {
			el.setAttribute('src', imgURL);
		}
	}
});

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
	return new Promise(resolve => {
		var img = new Image();
		img.onload = function() {
			if (this.complete == true) {
				resolve(true);
				img = null;
			}
		};
		img.onerror = function() {
			resolve(false);
			img = null;
		};
		img.src = url;
	});
};

/**
 * 默认导出
 */
export default {
	transNum2Cn, //数字转中文
	dateFormat, //时间转化
	openUrl, //打开网址
	throttle, //函数节流
	debounce, //函数防抖
	IsMobile, //判断手机号
	IsEmail, //判断邮箱
	IdentityCodeValid, //身份证号合法性验证
	validamount, //有效金额大于1的整数
	validnumber, //只能输入数字
	validChinese, //中文汉字
	isBankCardNo, //是否是正确的银行卡号
	escapeHtml, //字符转义
	openNewWindow,
	accessPermission,
	getBeviceInfo,
	getBeviceType,
	getBrowserBevice,
};
